import React, { useState } from "react";
import { createPortal } from "react-dom";
import ReactTooltip from "react-tooltip";
import "./jauge-remplissage-ep.scss";

// Compteur module : garantit des ids de tooltip uniques, une jauge par EP du
// calendrier.
let nbInstances = 0;

// Rayon d'un cercle de circonférence 100 : le tracé rempli se donne en
// pourcentage (stroke-dasharray « taux 100 »).
const RAYON = 100 / (2 * Math.PI);

/**
 * Jauge ronde du remplissage d'une EP (CE-1399) : remplie selon les inscrits et le
 * plafond, colorée quand l'EP approche du plafond ou est complète. Le détail
 * (« 69 / 200 dossiers inscrits ») s'affiche au survol ; les lecteurs d'écran
 * l'ont déjà dans le libellé de l'EP (libelleAccessible).
 *
 * L'infobulle est rendue dans le body, hors de l'EP : une vignette de la vue
 * classique survolée se soulève (transform) et coupe ce qui dépasse
 * (overflow-hidden), et une ligne de la vue compacte est un <button>.
 *
 * - remplissage : le résultat de remplissageEp(ep)
 * - complete : ep.isFull
 * - surFond : vignette colorée de la vue classique
 */
const JaugeRemplissageEp = ({ remplissage, complete = false, surFond = false }) => {
  const [tooltipId] = useState(() => `jauge-ep-${++nbInstances}`);
  const { inscrits, plafond, libelle, bientotComplete } = remplissage;
  const niveau = complete ? "complete" : bientotComplete ? "alerte" : "normal";
  const taux = Math.min(100, Math.round((inscrits / plafond) * 100));

  return (
    <span
      className={`jauge-ep jauge-ep--${niveau}${surFond ? " jauge-ep--sur-fond" : ""}`}
      data-tip={`${libelle} dossiers inscrits`}
      data-for={tooltipId}
      aria-hidden="true"
    >
      <svg className="jauge-ep__cercle" viewBox="0 0 36 36" focusable="false">
        <circle className="jauge-ep__fond" cx="18" cy="18" r={RAYON} />
        <circle className="jauge-ep__remplissage" cx="18" cy="18" r={RAYON} strokeDasharray={`${taux} 100`} />
      </svg>
      {createPortal(<ReactTooltip id={tooltipId} place="top" effect="solid" delayShow={0} />, document.body)}
    </span>
  );
};

export default JaugeRemplissageEp;
